import { useMemo } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from "react-router-dom";

const StoreListTable = ({ showActionButtons }) => {
  const navigate = useNavigate();

  const navigateToBranchSettings = (branchId) => {
    navigate(`/store/branch/settings/${branchId}`);
  };

  const data = [
    {
      id:'1',
      name: {
        firstName: 'John',
        lastName: 'Doe',
      },
      address: '261 Erdman Ford',
      city: 'East Daphne',
      state: 'Kentucky',
    },
    {    id:'2',
  
      name: {
        firstName: 'Jane',
        lastName: 'Doe',
      },
      address: '769 Dominic Grove',
      city: 'Columbus',
      state: 'Ohio',
    },
    {    id:'3',
  
      name: {
        firstName: 'Joe',
        lastName: 'Doe',
      },
      address: '566 Brakus Inlet',
      city: 'South Linda',
      state: 'West Virginia',
    },
    {    id:'4',
  
      name: {
        firstName: 'Kevin',
        lastName: 'Vandy',
      },
      address: '722 Emie Stream',
      city: 'Lincoln',
      state: 'Nebraska',
    },
    {    id:'5',
  
      name: {
        firstName: 'Joshua',
        lastName: 'Rolluffs',
      },
      address: '32188 Larkin Turnpike',
      city: 'Charleston',
      state: 'South Carolina',
    },
    {
      id:'1',
      name: {
        firstName: 'John',
        lastName: 'Doe',
      },
      address: '261 Erdman Ford',
      city: 'East Daphne',
      state: 'Kentucky',
    },
    {    id:'2',
  
      name: {
        firstName: 'Jane',
        lastName: 'Doe',
      },
      address: '769 Dominic Grove',
      city: 'Columbus',
      state: 'Ohio',
    },
    {    id:'3',
  
      name: {
        firstName: 'Joe',
        lastName: 'Doe',
      },
      address: '566 Brakus Inlet',
      city: 'South Linda',
      state: 'West Virginia',
    },
    {    id:'4',
  
      name: {
        firstName: 'Kevin',
        lastName: 'Vandy',
      },
      address: '722 Emie Stream',
      city: 'Lincoln',
      state: 'Nebraska',
    },
    {    id:'5',
  
      name: {
        firstName: 'Joshua',
        lastName: 'Rolluffs',
      },
      address: '32188 Larkin Turnpike',
      city: 'Charleston',
      state: 'South Carolina',
    },
  ];

  
  // Define columns
  const columns = useMemo(
    () => [
      {
        accessorKey: 'id',
        header: 'Id',
        size: 15,
      },
      {
        accessorKey: 'name.lastName',
        header: 'Branch Location',
        size: 150,
      },
      {
        accessorKey: 'name.lastName',
        header: 'Customer Support Email',
        size: 150,
      },
      {
        accessorKey: 'address',
        header: 'Customer Support',
        size: 200,
      },
      {
        accessorKey: 'city',
        header: 'Branch Manager',
        size: 150,
      },
      {
        accessorKey: 'state',
        header: 'Staffs Count',
        size: 150,
      },
    ],
    []
  );

  // Define table with or without action buttons based on showActionButtons prop
  const table = useMaterialReactTable({
    columns,
    data,
    ...(showActionButtons
      ? {
          enableRowActions: true,
          positionActionsColumn:"last",
          renderRowActionMenuItems: ({ row }) => [
            <MenuItem key="edit" onClick={() => console.info('Edit')}>
              View 
            </MenuItem>,
            <MenuItem key="edit" onClick={() => navigateToBranchSettings(row.id)}>
              Edit Branch Details
            </MenuItem>,
            <MenuItem key="delete" onClick={() => console.info('Delete')}>
              Delete Branch
            </MenuItem>,
            
          ],
        }
      : {})
  });

  return <MaterialReactTable table={table} />;
};

export default StoreListTable;
